import { FaRegMap } from "react-icons/fa";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import useDispatchDashboard from "hooks/dispatch/useDispatchDashboard";
import FleetMap from "./components/FleetMap";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function DispatchDashboard() {
  const {
    currentLocation,
    driverLocation,
    showDriverInfo,
    tripOverview,
    dispatchedByDispatcherPercent,
    dispatchedByAppPercent,
    handleCloseDriverInfo,
    handleShowDriverInfo,
    refreshDriversLocation,
    isRefreshingDrivers,
    excludeStuckDrivers,
    setExcludeStuckDrivers,
  } = useDispatchDashboard();

  return (
    <div className="w-full p-2 flex flex-col gap-4 grow">
      {/* First Row */}
      <div className="flex justify-between gap-4">
        <div className="flex-1 bg-white p-4 shadow-lg flex flex-col items-center">
          <div
            className={`p-4 rounded-full bg-gray-200 flex items-center justify-center`}
          >
            <FaRegMap color="black" size={24} />
          </div>
          <p className="mt-2 text-xl font-bold">{tripOverview?.total}</p>
          <p className="mt-1">Total Trips</p>
        </div>
        <div className="flex-1 bg-white p-4 shadow-lg flex flex-col items-center">
          <div
            className={`p-4 rounded-full bg-green-200 flex items-center justify-center`}
          >
            <FaRegMap color="green" size={24} />
          </div>
          <p className="mt-2 text-xl font-bold">{tripOverview?.completed}</p>
          <p className="mt-1">Completed Trips</p>
        </div>
        <Link
          to={RouteName.TRIP}
          className="flex-1 bg-white p-4 shadow-lg flex flex-col items-center cursor-pointer hover:shadow-xl transition-shadow duration-200"
        >
          <div
            className={`p-4 rounded-full bg-orange-200 flex items-center justify-center`}
          >
            <FaRegMap color="orange" size={24} />
          </div>
          <p className="mt-2 text-xl font-bold">{tripOverview?.ongoing}</p>
          <p className="mt-1">Trips in Progress</p>
        </Link>
        <div className="flex-1 bg-white p-4 shadow-lg flex flex-col items-center">
          <div
            className={`p-4 rounded-full bg-red-200 flex items-center justify-center`}
          >
            <FaRegMap color="red" size={24} />
          </div>
          <p className="mt-2 text-xl font-bold">{tripOverview?.cancelled}</p>
          <p className="mt-1">Cancelled Trips</p>
        </div>
        <div className="flex-1 bg-white p-4 shadow-lg flex flex-col items-center">
          <div
            className={`p-4 rounded-full bg-red-200 flex items-center justify-center`}
          >
            <FaRegMap color="orange" size={24} />
          </div>
          <p className="mt-2 text-xl font-bold">{tripOverview?.available}</p>
          <p className="mt-1">Declined Trips</p>
        </div>
      </div>

      <div className="flex justify-between gap-4 grow">
        <div className="w-1/4 bg-white p-4 shadow-lg flex flex-col items-center">
          {" "}
          {/* 30% width */}
          <div className="w-full h-full flex flex-col  justify-center">
            {" "}
            {/* Ensure the pie chart occupies full container */}
            <p className="mt-2 text-xl font-bold p-4">Booking Methods</p>
            <Pie
              data={{
                labels: ["App", "Dispatcher"],
                datasets: [
                  {
                    data: [
                      tripOverview?.dispatched_by_app || 0,
                      tripOverview?.dispatched_by_dispatcher || 0,
                    ],
                    backgroundColor: ["#ffc07d", "#9485fc"],
                    hoverBackgroundColor: ["#ffc07d", "#9485fc"],
                  },
                ],
              }}
              width={150}
              height={150}
            />{" "}
            {/* Increase width and height */}
          </div>
          <p className="mt-1">
            App: {tripOverview?.dispatched_by_app} ({dispatchedByAppPercent}%)
          </p>
          <p className="mt-1">
            Dispatcher: {tripOverview?.dispatched_by_dispatcher} (
            {dispatchedByDispatcherPercent}%)
          </p>
        </div>
        <FleetMap
          currentLocation={currentLocation}
          driverLocation={driverLocation}
          handleCloseDriverInfo={handleCloseDriverInfo}
          handleShowDriverInfo={handleShowDriverInfo}
          showDriverInfo={showDriverInfo}
          onRefreshDrivers={refreshDriversLocation}
          isRefreshingDrivers={isRefreshingDrivers}
          excludeStuckDrivers={excludeStuckDrivers}
          onToggleExcludeStuck={() => setExcludeStuckDrivers(!excludeStuckDrivers)}
        />
      </div>
    </div>
  );
}
